import type { Collection } from '../../../collection'
import type * as ecModels from '../../../models'
import type * as plugin from '../../plugin'

import { Plugin } from './plugin'

/**
 * {@link plugin.Plugin.Factory} for this {@link Plugin}
 * ({@link plugin.Plugin.Id.Standard.Attribute})
 */
export class Factory<TTypeParams extends ecModels.TypeParams>
  implements
    plugin.Plugin.Factory<
      TTypeParams,
      plugin.Plugin.Id.Standard.Attribute,
      Plugin<TTypeParams>
    >
{
  public readonly id = Plugin.Id.Standard.Attribute

  public produceFor(collection: Collection<TTypeParams>): Plugin<TTypeParams> {
    return new Plugin<TTypeParams>({ collection })
  }
}
